module.exports = __webpack_public_path__ + "assets/img/6-mobile.85231778.png";